import React from "react";

export const Card: React.FC<{ children: React.ReactNode; className?: string; hover?: boolean }> = ({
  children,
  className = "",
  hover = true,
}) => (
  <div
    className={`rounded-xl border border-[var(--site-border)] bg-[var(--site-surface)] p-6 text-[var(--site-text)] backdrop-blur-sm transition-colors ${
      hover ? "hover:border-[var(--site-border-strong)]" : ""
    } ${className}`}
  >
    {children}
  </div>
);
